window.addEventListener('DOMContentLoaded', () => {


    function createHiddenInput(value) {
        let hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = 'properties[Gown Handle]';
        hiddenInput.value = value;
        return hiddenInput;
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const gownParamValue = urlParams.get('gown');
    if (gownParamValue) {
        console.log(gownParamValue);

        const productMainForm = document.querySelector('.wt-product__add-to-cart_form.form');
        if (!productMainForm) return;

        const hiddenInput = createHiddenInput(gownParamValue);
        productMainForm.appendChild(hiddenInput);
    }
});